import AddToWishlist from '@/components/ui/buttons/add-to-wishlist';
import CartPopup from './CartPopup';
import Account from './account';
import LocaleSwitcher from '@/components/ui/local-switcher';

const UserActions = () => {
  return (
    <div className='flex items-center justify-center gap-4 font-bold'>
      <Account />
      <div className='hidden h-[29px] w-px bg-[#D3D3D3] lg:flex' />

      <LocaleSwitcher className='hidden lg:flex' />
      <div className='hidden h-[29px] w-px bg-[#D3D3D3] lg:flex' />

      <AddToWishlist title={'FAVORITE'} className='hidden lg:flex' />
      <div className='hidden h-[29px] w-px bg-[#D3D3D3] lg:flex' />

      <CartPopup />
    </div>
  );
};

export default UserActions;
